import React, { useEffect, useState } from 'react'

import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import { Button } from 'ziphy-web-shared/basic/lib/buttons'

import { $booking } from '@store'

import BookingLayout from '../../../library/bookingLayout/BookingLayout'
import AllSymptoms from '../../../pages/bookingSymptoms/bookingSelectSymptoms/allSymptoms/AllSymptoms'
import CategorizedSymptoms from '../../../pages/bookingSymptoms/bookingSelectSymptoms/categorizedSymptoms/CategorizedSymptoms'
import CommonSymptoms from '../../../pages/bookingSymptoms/bookingSelectSymptoms/commonSymptoms/CommonSymptoms'
import SelectedSymptoms from '../../../pages/bookingSymptoms/bookingSelectSymptoms/selectedSymptoms/SelectedSymptoms'
import SymptomsSearchBar from '../../../pages/bookingSymptoms/bookingSelectSymptoms/SymptomsSearchBar'

const BookingSelectSymptoms = ({ service, breadcrumbs, onClickNext }) => {
  const { t } = useTranslation()

  const [searchString, setSearchString] = useState('')
  const [isAllVisible, setIsAllVisible] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState(null)

  useEffect(() => {
    if (!$booking.$symptoms.isLoading) {
      setIsAllVisible(!$booking.$symptoms.common.length)
    }
  }, [$booking.$symptoms.isLoading])

  return (
    <BookingLayout
      title={t('book.ph.symptoms')}
      breadcrumbs={breadcrumbs}
      isMobileFooterFixed={true}
      button={
        <Button
          disabled={service.hasSymptoms ? !$booking.$symptoms.selectedIds.length : false}
          onClick={onClickNext}
        >
          {t('btn.next')}
        </Button>
      }
      isDesktopFooterFixed={true}
      isLoading={$booking.$symptoms.isLoading}
    >
      <SymptomsSearchBar onChange={setSearchString} />
      <SelectedSymptoms />

      {!searchString.length && (
        <div className="simple_header mb-10 mt-30">
          <div className="title-sm mb-0">
            {selectedCategory
              ? selectedCategory.category
              : t(isAllVisible ? 'symptoms.groups.all' : 'symptoms.groups.common')}
          </div>
          {$booking.$symptoms.common.length > 0 && (
            <div
              className="simple_header-link"
              onClick={() => {
                if (selectedCategory) {
                  setSelectedCategory(null)
                  setIsAllVisible(false)
                } else {
                  setIsAllVisible(!isAllVisible)
                }
              }}
            >
              {t(
                isAllVisible || selectedCategory
                  ? 'symptoms.btn.common_symptoms'
                  : 'symptoms.btn.all',
              )}
            </div>
          )}
        </div>
      )}

      {searchString.length || isAllVisible || selectedCategory ? (
        <AllSymptoms
          items={$booking.$symptoms.categorized}
          selectedCategory={selectedCategory}
          searchString={searchString}
        />
      ) : (
        <>
          <CommonSymptoms items={$booking.$symptoms.common} />
          <CategorizedSymptoms
            items={$booking.$symptoms.categorized}
            selectedCategory={selectedCategory}
            onSelectCategory={setSelectedCategory}
          />
        </>
      )}
    </BookingLayout>
  )
}

export default observer(BookingSelectSymptoms)
